<div id="rename-file-dialog-container">
    <div id="rename-file-dialog-title-container">
        <H2
            matTooltip="{{ 'dialog.rename-file.label.title' | translate: { filename: file.name.substring(0, file.name.lastIndexOf('.')) }  }}">
            {{ 'dialog.rename-file.label.title' | translate: { filename: file.name.substring(0, file.name.lastIndexOf('.')) } }}
        </H2>
        <button id="close-dialog-button" mat-icon-button (click)="closeDialog()"
            matTooltip="{{ 'general.tooltip.close-dialog' | translate }}" color="warn">
            <mat-icon>clear</mat-icon>
        </button>
    </div>
    <div id="rename-file-dialog-content">
        <div id="rename-file-dialog-language-container">
            <div class="language-selector" [ngClass]="[!selectedLanguage ? 'selected-language': '']"
                (click)="selectLanguage(null)"
                matTooltip="{{ 'dialog.rename-file.tooltip.edit-base-info' | translate }}">
                <img src="assets/svg/flags/082-united-nations.svg">
            </div>
            <div class="language-selector" [ngClass]="[selectedLanguage == 'it' ? 'selected-language': '']"
                (click)="selectLanguage('it')" matTooltip="{{ 'dialog.rename-file.tooltip.edit-it-info' | translate }}">
                <img src="assets/svg/flags/013-italy.svg">
            </div>
            <div class="language-selector" [ngClass]="[selectedLanguage == 'en' ? 'selected-language': '']"
                (click)="selectLanguage('en')" matTooltip="{{ 'dialog.rename-file.tooltip.edit-en-info' | translate }}">
                <img src="assets/svg/flags/260-united-kingdom.svg">
            </div>
        </div>
        <div id="rename-file-dialog-form-container">
            <div *ngIf="selectedLanguage && !file.translations.get(selectedLanguage) && !creatingNew">
                <button mat-button color="primary" (click)="createNewTranslation()">
                    {{ 'dialog.rename-file.button.add-translation' | translate }}
                </button>
            </div>
            <form id="rename-file-dialog-form" [formGroup]="form" (submit)="submit()"
                *ngIf="!selectedLanguage || file.translations.get(selectedLanguage) || creatingNew">
                <mat-error *ngIf="renameFileError">
                    {{renameFileError}}
                </mat-error>
                <mat-form-field class="full-width-input">
                    <input matInput type="text"
                        placeholder="{{ 'dialog.rename-file.placeholder.file-name' | translate }}"
                        formControlName="filename" required>
                    <span matSuffix> {{ extension }} </span>
                    <mat-error *ngIf="formSubmitAttempt">
                        {{ 'dialog.rename-file.error.invalid-file-name' | translate }}
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="full-width-input">
                    <textarea matInput type="text"
                        placeholder="{{ 'dialog.rename-file.placeholder.file-description' | translate }}"
                        formControlName="description"></textarea>
                    <mat-error *ngIf="formSubmitAttempt">
                        {{ 'dialog.rename-file.error.invalid-file-description' | translate }}
                    </mat-error>
                </mat-form-field>
                <div id="rename-file-action-container">
                    <button type="button" id="rename-file-button-remove" mat-button color="primary"
                        *ngIf="!edited() && selectedLanguage" (click)="deleteTranslation()">
                        {{ 'dialog.rename-file.button.delete-translation' | translate | uppercase }}
                    </button>

                    <button type="button" id="rename-file-button-cancel" mat-button
                        [disabled]="!edited() && !createNewTranslation" color="warn" *ngIf="edited()"
                        (click)="cancel()">
                        {{ 'general.button.cancel' | translate | uppercase }}
                    </button>
                    <button type="submit" id="rename-file-button-submit" mat-button [disabled]="!edited()"
                        color="primary">
                        {{ 'general.button.save' | translate | uppercase }}
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>